import React, { Fragment, useState, useEffect, useCallback, memo } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import NotificationsActiveTwoToneIcon from '@material-ui/icons/NotificationsActiveTwoTone';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { setIsNewEmailNotification } from '../../reducers/User';
import SocketService from '../../socketService';
import NewNotificationSnackbarAlert from './NotificationSnackbarAlert';
import { get } from 'lodash';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Badge from '@material-ui/core/Badge';
import { Typography } from '@material-ui/core';

const Notification = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [count, setCount] = useState(0);
  const userId = useSelector(state => state.User.user?.id);
  const notifications = useSelector(state => state.Watchlist.notifications);

  const getNotifications = useCallback(() => {
    let countSum = 0;
    notifications.forEach(element => {
      if (!element.is_read) {
        countSum = countSum + 1;
      }
      setCount(countSum);
    });
  }, [notifications]);

  useEffect(() => {
    getNotifications();
  }, [getNotifications]);

  useEffect(() => {
    if (userId && SocketService.socket) {
      SocketService.socket.connect();
      SocketService.socket.emit('join_room', userId);
      SocketService.socket.on(userId, function(data) {
        if (get(data, 'status', false)) {
          dispatch(setIsNewEmailNotification(true));
        }
      });
    } else if (SocketService?.socket) {
      SocketService.socket.close();
    }
  }, [dispatch, userId]);

  const open1 = Boolean(anchorEl1);
  const handleClose1 = () => {
    setAnchorEl1(null);
    resetCounter();
  };

  const resetCounter = () => {
    setCount(0);
  };

  const handleEmailTemplate = (link, id) => {
    handleClose1();
    // dispatch(setSelectedWatchlist(null));
    // current time stamps will help to re-render useEffect if user click same notification again in themeX
    link = `${link}&ts=${Date.now()}`;
    setTimeout(() => history.push(link), 100);
  };
  const deleteNotification = async () => {
    try {
      await axios.delete('/api/email/notification');
    } catch (error) {
      console.log(error);
    }
  };
  const handleClick1 = event => {
    setAnchorEl1(event.currentTarget);
    deleteNotification();
  };
  const getTitle = data => {
    let title = get(data, 'title', '');
    if (title.toLocaleLowerCase() === 'FMP-Transcript'.toLocaleLowerCase()) {
      title = 'Earnings Call';
    }
    if (title.toLowerCase() === 'ThemeX Alert'.toLocaleLowerCase()) {
      title = `ThemeX (${get(data, 'topic', '')})`;
    }
    return title;
  };

  const getTime = v => {
    return moment.unix(v).format('hh:mm A');
  };

  const getNotificationDescription = data => {
    let tweetDescription = '';
    let tickerArr = get(data, 'tickerArr', null);
    if (tickerArr) {
      tweetDescription = tickerArr.length > 3 ? tickerArr.slice(0, 3).join(', ') + ' ...' : tickerArr.join(',');
    } else {
      tweetDescription = data.description;
    }

    return tweetDescription;
  };
  return (
    <Fragment>
      <Hidden>
        <Box component="span">
          <div className={classes.badgeContainer}>
            <Badge className={classes.pointer} onClick={handleClick1} badgeContent={count} color="error">
              <NotificationsActiveTwoToneIcon />
            </Badge>
          </div>
          {open1 ? (
            <Popover
              open={open1}
              anchorEl={anchorEl1}
              onClose={handleClose1}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                style: { marginTop: '5px', width: '400px' },
              }}>
              <div className={classes.container}>
                <div className={classes.dialogHeader}>
                  <p className={classes.headerText}>
                    You have <b style={{ color: '#1bc943' }}>{count}</b> new messages.
                  </p>
                </div>
                <div className={classes.popoverHeight}>
                  <PerfectScrollbar>
                    <Box className={classes.timelineList}>
                      {notifications.map((data, index) => (
                        <Box
                          key={index}
                          className={classes.timelineItem}
                          onClick={() => handleEmailTemplate(data.link, get(data, 'searchId', null))}>
                          <Box className={classes.timeContainer}>
                            <Typography className={classes.timeText}>
                              {getTime(get(data, 'email_time', null))}
                            </Typography>
                          </Box>
                          <Box className={classes.timelineIcon} />
                          <Box className={classes.timelineContent}>
                            <Typography className={classes.notificationTitle}>{getTitle(data)}</Typography>
                            <Typography className={classes.notificationDescription}>
                              {getNotificationDescription(data)}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </PerfectScrollbar>
                </div>
              </div>
            </Popover>
          ) : null}
        </Box>
      </Hidden>
      <NewNotificationSnackbarAlert />
    </Fragment>
  );
};

export default memo(Notification);

const useStyles = makeStyles(theme => ({
  badgeContainer: { padding: '0 1.1rem 0 0.8rem' },
  bellIcon: {
    padding: '0px',
    margin: '0px',
    height: '40px',
    lineHeight: '40px',
    width: '40px',
  },
  pointer: {
    cursor: 'pointer',
  },
  dialogHeader: {
    backgroundColor: theme.palette.secondary.main,
    textAlign: 'center',
    margin: '0.5rem',
    borderRadius: '0.29rem',
  },
  popoverHeight: {
    height: '280px',
  },
  container: { overflow: 'hidden' },
  headerText: { color: '#f4f5fd', padding: '1.5rem 0' },
  timelineList: {
    position: 'relative',
    padding: '10px 0',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '60px',
      width: '2px',
      height: '100%',
      backgroundColor: '#E0E0E0',
    },
  },
  timelineIcon: {
    position: 'absolute',
    top: '3px',
    left: '55px',
    width: '12px',
    height: '12px',
    backgroundColor: '#ffffff',
    border: '2px solid #c2c2c2',
    borderRadius: '50%',
  },
  timelineItem: { display: 'flex', marginBottom: '20px', position: 'relative', cursor: 'pointer' },
  timeContainer: { width: '50px', textAlign: 'right', paddingRight: '5px' },
  timelineContent: { paddingLeft: '30px' },
  timeText: { fontSize: '12px', opacity: 0.5, textAlign: 'right' },
  notificationTitle: { fontWeight: 'bold', fontSize: '14px' },
  notificationDescription: { fontSize: '12px', color: theme.palette.text.secondary },
}));
